<template>
                        <div class="dropdown for-notification">
                          <!--<button class="btn btn-secondary dropdown-toggle" type="button" id="notification" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">-->
                            <!--<i class="fa fa-bell"></i>-->
                            <!--<span class="count bg-danger">5</span>-->
                          <!--</button>-->
                          <!--<div class="dropdown-menu" aria-labelledby="notification">-->
                            <!--<p class="red">You have 3 Notification</p>-->
                            <!--<a class="dropdown-item media bg-flat-color-1" href="#">-->
                                <!--<i class="fa fa-check"></i>-->
                                <!--<p>Server #1 overloaded.</p>-->
                            <!--</a>-->
                            <!--<a class="dropdown-item media bg-flat-color-4" href="#">-->
                                <!--<i class="fa fa-info"></i>-->
                                <!--<p>Server #2 overloaded.</p>-->
                            <!--</a>-->
                            <!--<a class="dropdown-item media bg-flat-color-5" href="#">-->
                                <!--<i class="fa fa-warning"></i>-->
                                <!--<p>Server #3 overloaded.</p>-->
                            <!--</a>-->
                          <!--</div>-->
                        </div>
</template>

<script>
export default {
  name: 'HeaderNotification',
  data(){

	  return { }
  },
  methods:{
    something(e){
      return e;
    },
  }

};
</script>

<style>

</style>


